import {
  formPost,
  formPostJsonResponse,
  htmlGet,
  htmlPost,
  jsonPost
} from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import * as constantConfig from '../utilities/constant_config';
import checkoutAddInsurance from './checkout_insurance_add';
import { selectmenuAccessibilityCompliance } from '../utilities/helper';

$(function() {
  let searchInsuranceListAjaxReq = true;
  let onClickRemoveInsuranceListAjaxReq = true;
  let onClickSubmitInsuranceListAjaxReq = true;
  let onSaveAdjustedInsuranceAjaxReq = true;
  const viewHealthInsurancesUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.insurance.showHealthInsurances}`;
  let insuranceFlag = true;

  function loadingInsurancePage() {
    htmlGet(viewHealthInsurancesUrl)
      .then(data => {
        onClickRemoveInsuranceListAjaxReq = true;
        searchInsuranceListAjaxReq = true;
        onClickSubmitInsuranceListAjaxReq = true;
        loadingHtmlAfterAjax(data);
      })
      .catch(error => {
        onClickRemoveInsuranceListAjaxReq = true;
        searchInsuranceListAjaxReq = true;
        onClickSubmitInsuranceListAjaxReq = true;
      });
  }

  function attachAddInsuranceEvent() {
    $(document).on(
      'click',
      '.account-health-insurance__add',
      onClickAddInsurance
    );
    $('img.icon-add-insurance')
      .addClass('svg-icon_circle_plus_blue svg-icon_circle_plus_blue-dims')
      .css('cursor', 'pointer');
    $(
      '.account-health-insurance__add .account-health-insurance__add-label'
    ).css('color', '#0E7D9C');
    $('.disableInsurance').removeClass('show');
  }

  function searchInsuranceList() {
    var $spinner = $('#health-add-insurance .spinner-mask');
    const checkoutParent = $('.checkout-add-insurance');
    var healthAddInsuranceData = $('#health-add-insurance').serialize();
    const requiredInsurance = checkoutParent.data('requiredInsurance');
    if (
      checkoutParent.length &&
      requiredInsurance.errorSubtype === constantConfig.EXPIRED_INSURANCE
    ) {
      healthAddInsuranceData += '&checkoutFlow=true';
    }
    var formURL = `${ACC.config.encodedContextPath}${API_REFERENCE.accountInsurance.searchInsurance}`;
    if (!searchInsuranceListAjaxReq) return false;
    if(window.location.pathname.indexOf('checkout') > 0) { 
      if(! checkoutAddInsurance.checkFlag()) return false;
    }
    searchInsuranceListAjaxReq = false;
	   $spinner.removeClass('hidden');
    htmlPost(formURL, healthAddInsuranceData)
      .then(responseData => {
		$spinner.addClass('hidden');
        const $addInsuranceContainer = $(
          '.health-add-insurance-search-section'
        );
        const data = ACC.sanitizer.sanitizeHtmlDeeply(responseData);
        $addInsuranceContainer.html(data);
        if (checkoutParent.length) {
          $addInsuranceContainer
            .find('.health-add-insurance__btn-section')
            .remove();
          $addInsuranceContainer
            .find('.checkout-add-insurance__btn-section')
            .removeClass('hidden');
        }
        if ($('#selectedPlansFlg').val() === 'true') {
          if (!checkoutParent.length) {
            loadingInsurancePage();
          } else {
            searchInsuranceListAjaxReq = true;
            checkoutAddInsurance.checkoutSelectedPlanProcess();
          }
        } else if ($('#eStatus').val() === 'FAILURE') {
          searchInsuranceListAjaxReq = true;
          $('.noInsuranceExist').removeClass('hidden');
        } else {
          searchInsuranceListAjaxReq = true;
          $addInsuranceContainer.removeAttr('hidden');
          if (
            $addInsuranceContainer.find('.checkout-ins-search__radio').length >
            0
          ) {
            $(window).scrollTop(
              $addInsuranceContainer.offset().top -
                parseInt($('.nav-header').height())
            );
          }
        }
        $spinner.prop('hidden', true);
      })
      .catch(error => {
		  $(".health-add-insurance-search-section").html(`<div class="col-xs-12 noRecordDiv record-unsuccessful mb-5 mt-5 px-0">
						<div class="alert-error">
							<div>
							<span class="svg-icon_alert_fill_red svg-icon_alert_fill_red-dims"></span>
							</div>
							<span class="alert-error__msg" role="alert">
								The system is down<span>         
						</div>
					</div>`).removeAttr('hidden');
        searchInsuranceListAjaxReq = true;
        $spinner.prop('hidden', true);
		$spinner.addClass('hidden');
      });
  }

  function searchInsuranceListRemove() {
    $('.health-remove-insurance-search-section').show('slow', function() {
      $(window).scrollTop(
        $('.health-remove-insurance-search-section').offset().top
      );
    });
  }

  function validateAllInputFields(e) {
    e.preventDefault();
    $('#health-add-insurance .spinner-mask').prop('hidden', false);
    if (insuranceFlag) {
      searchInsuranceList();
    }
  }

  function validateAllInputFieldsRemove(e) {
    e.preventDefault();
    searchInsuranceListRemove();
  }

  function validateInput() {
    const thisId = $(this).attr('id');
    $(this)
      .next('.error-msg-text')
      .attr('hidden', true);
    $(this)
      .siblings('.error-msg-text')
      .attr('hidden', true);
    $(this)
      .siblings('.ui-selectmenu-button')
      .removeClass('error');
    $(this).removeClass('error-msg-textbox');
    if ($(this).val() === '') {
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    } else if (
      thisId === 'memberIdInsurance' &&
      $(this)[0].validity.patternMismatch
    ) {
      $(this)
        .siblings('.error-msg-length')
        .removeAttr('hidden');
      $(this).addClass('error-msg-textbox');
    }
  }

  function onClickCancel() {
    $('.health-remove-insurance-adjust-drop').removeClass('custom-input-valid');

    //resetting hidden fields if action is cancelled
    $('#removedValue').val('');
    $('#health-add-insurance #payerPosition').val('');
    $('#removedPlanId').val('');
    $('#planIdToRemove').val('');
    $('#removedCustomerPlanRltId').val('');
    $('#removePlanErrorMsg').addClass('hidden');
    $('.custom-input-valid').each(function(i, el) {
      var $this = $(el);
      $this.next('.error-msg-text').attr('hidden', true);
      $this.removeClass('error');
      $this
        .siblings('.ui-selectmenu-button')
        .removeClass('error error-msg-textbox');
      $this
        .next()
        .next('.error-msg-text')
        .addClass('hidden');
    });
    onClickCancelAdjustment();
    $('#CHHAdjustHealthInsuranceForm')[0].reset();
    $('#health-add-insurance')[0].reset();
    $('.health-remove-insurance').hide();
    $('.account-health-insurance').show();
    $('.health-add-insurance').hide();
    $('.account-health-insurance-policy-info').show();
    $('.view-insurance-remove-desc').addClass('hidden');
    $('.view-description').removeClass('hidden');
    attachAddInsuranceEvent();
    $(window).scrollTop($('.view-top').offset().top);
  }

  function onClickCancelAdjustment(e) {
    $('.custom-input-valid').each(function(i, el) {
      var $this = $(el);
      $this.next('.error-msg-text').attr('hidden', true);
      $this.removeClass('error-msg-textbox');
    });

    $('.insurance-remove-initiate').removeClass(
      'health-remove-insurance-margin'
    );
    $('input[type=radio][name=removeInsurance][value="adjust"]')
      .prop('checked', true)
      .trigger('change');
    $('.health-remove-insurance').hide();
    $('.health-remove-insurance-search-section').hide();
    $('.health-remove-insurance-addnew-section').hide();
    $('.health-remove-insurance-adjust-section').show();
    $('.account-health-insurance-policy-info').show();
    $(window).scrollTop($('.view-top').offset().top);
    $('.account-health-insurance').removeClass('mx-4');
  }

  function setInsuranceActiveInactive() {
    if ($('#externalInsuranceNumber').val() == 4) {
      $('img.icon-add-insurance')
        .addClass('svg-icon_circle_plus svg-icon_circle_plus-dims')
        .css('cursor', 'none');
      $('.account-health-insurance__add-label').addClass(
        'healthInsuranceAddInactive'
      );
      $('.account-health-insurance__add-limit').addClass(
        'healthInsuranceAddInactive'
      );
    } else if ($('#externalInsuranceNumber').val() < 4) {
      $('.account-health-insurance__add-label').removeClass(
        'healthInsuranceAddInactive'
      );
      $('.account-health-insurance__add-limit').removeClass(
        'healthInsuranceAddInactive'
      );
      $('img.icon-add-insurance')
        .addClass('svg-icon_circle_plus_blue svg-icon_circle_plus_blue-dims')
        .css('cursor', 'pointer');
    }
  }

  function onClickAddInsurance() {
    $.each(elements, function(i, inputVal) {
      inputVal.addEventListener('invalid', function(e) {
        e.preventDefault();
      });
    });

    $('.noInsuranceExist').addClass('hidden');
    if ($('#externalInsuranceNumber').val() < 4) {
      $('.health-add-insurance').show();
      $('.account-health-insurance-policy-info').hide();
      $('#health-add-insurance-search').hide();
      $('.account-health-insurance').addClass('mx-4');
      $('#removePlanErrorMsg').addClass('hidden');
      $('#adjustPlanErrorMsg').addClass('hidden');
      $('.addInsuranceErrorDiv').attr('hidden', true);
      $('#t1_insuranceType').focus();
      $('.health-add-insurance__select-policy').selectmenu();
      $('.health-add-insurance__select-state').selectmenu();
      selectmenuAccessibilityCompliance();
    }
  }

  function onClickRemoveInsurance(e) {
    e.preventDefault();
    var removed = $(this).attr('id');
    var planId = $(this).val();
    var position = $(this).attr('position');

    $('#removedValue').val(removed);
    $('#health-add-insurance #payerPosition').val(position);
    $('#removedPlanId').val(planId);
    $('#planIdToRemove').val(planId);
    $('#removedCustomerPlanRltId').val(removed);
    $('#removePlanErrorMsg').addClass('hidden');
    $('#adjustPlanErrorMsg').addClass('hidden');
    $('.addInsuranceErrorDiv').attr('hidden', true);

    if ($(this).hasClass('lastelement')) {
      $('.view-insurance-remove-desc').addClass('hidden');
      $('.view-description').removeClass('hidden');
      var lastPlan = $(this).val();
      var customerPlanRltIdToRemove = $(this).attr('id');
      var requestData = {
        planId: lastPlan,
        customerPlanRltId: customerPlanRltIdToRemove
      };
      const removeHealthInsuranceUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountInsurance.removeHealthInsurance}`;
      const removeInsuranceData = JSON.stringify(requestData);
      if (!onClickRemoveInsuranceListAjaxReq) return false;
      onClickRemoveInsuranceListAjaxReq = false;
      jsonPost(removeHealthInsuranceUrl, removeInsuranceData)
        .then(data => {
          data = JSON.parse(data);
          if (data.status === 'SUCCESS') {
            loadingInsurancePage();
          } else {
            onClickRemoveInsuranceListAjaxReq = true;
            $('#removePlanErrorMsg').removeClass('hidden');
          }
        })
        .catch(error => {
          onClickRemoveInsuranceListAjaxReq = true;
        });
    } else {
      toggleSaveButtonState();
      $(document).off(
        'click',
        '.account-health-insurance__add',
        onClickAddInsurance
      );
      $('img.icon-add-insurance')
        .addClass('svg-icon_circle_plus svg-icon_circle_plus-dims')
        .css('cursor', 'none');
      $('.account-health-insurance__add').attr('tabindex', '-1');
      $(
        '.account-health-insurance__add .account-health-insurance__add-label'
      ).css('color', '#ccc');
      $('.disableInsurance').addClass('show');
      $('.insurance-remove-initiate').addClass(
        'health-remove-insurance-margin'
      );
      $('.health-remove-insurance').show();
      $('.health-remove-insurance-adjust-drop').addClass('custom-input-valid');
      $('.health-remove-insurance-adjust-drop').selectmenu();
      $('.health-remove-insurance-adjust-drop option').attr('disabled', false);
      $('.view-insurance-remove-desc').removeClass('hidden');
      $('.view-description').addClass('hidden');
      $('.health-remove-insurance-adjust-drop').data('selected', removed);
      $('.health-remove-insurance-adjust-drop option:first-child')
        .prop('selected', true)
        .attr('disabled', true);
      $(
        ".health-remove-insurance-adjust-drop option[value='" + removed + "']"
      ).attr('disabled', true);
      $('.health-remove-insurance-adjust-drop').selectmenu('refresh');
      $('.account-health-insurance-policy-info').hide();
      $('#health-add-insurance-search').hide();
    }
  }

  function onChangeInsuranceAdjustment() {
    $('.addInsuranceErrorDiv').attr('hidden', true);
    $('#removePlanErrorMsg').addClass('hidden');
    $('#adjustPlanErrorMsg').addClass('hidden');
    if ($(this).val() === 'replace') {
      $('.health-remove-insurance-adjust-section').hide();
      $('.custom-input-valid').each(function(i, el) {
        var $this = $(el);
        $this.removeClass('error-msg-textbox');
      });
      $('.health-remove-insurance-heading__adjust').addClass('hidden');
      $('.health-remove-insurance-heading__replace').removeClass('hidden');
      $('.health-remove-insurance-addnew-section').show();
      $('.health-remove-insurance-form__divider').removeClass('hidden');
      $(
        '.health-add-insurance__select-state,.health-add-insurance__select-policy'
      ).selectmenu();
    } else if ($(this).val() === 'adjust') {
      $('.health-remove-insurance-heading__adjust').removeClass('hidden');
      $('.health-remove-insurance-heading__replace').addClass('hidden');
      $('.health-remove-insurance-adjust-section').show();
      $('.health-remove-insurance-addnew-section').hide();
      $('.health-remove-insurance-form__divider').addClass('hidden');
    }
  }

  function validateAddRowButton() {
    if ($('.account-health-insurance__section').length >= 4) {
      $('.account-health-insurance__add').off('click', onClickAddInsurance);
    }
  }

  function onChangeInsuranceType(e) {
    e.preventDefault();
    $('.health-add-insurance__type .custom-input-valid').each(function(i, el) {
      var $this = $(el);
      $this
        .parent('.checkout-add-insurance__type')
        .siblings('.typeOfInsurance_error')
        .attr('hidden', true);
      $this.removeClass('error-msg-textbox');
    });
  }

  function onSubmitAddInsurance() {
    var $spinner = $('#health-add-insurance .spinner-mask');
    $spinner.prop('hidden', false);
    var formURL = `${ACC.config.encodedContextPath}${API_REFERENCE.accountInsurance.showAddInsurance}`;
    const showAddInsuranceData = $('#health-add-insurance-search').serialize();
    if (!onClickSubmitInsuranceListAjaxReq) return false;
    onClickSubmitInsuranceListAjaxReq = false;
    formPost(formURL, showAddInsuranceData)
      .then(data => {
        if (data === 'FAILURE') {
          onClickSubmitInsuranceListAjaxReq = true;
          $('.addInsuranceErrorDiv').attr('hidden', false);
          $spinner.prop('hidden', true);
        } else if (data === 'SUCCESS') {
          loadingInsurancePage();
        }
      })
      .catch(error => {
        onClickSubmitInsuranceListAjaxReq = true;
        $spinner.prop('hidden', true);
      });
    return false;
  }

  function onSubmitAddInsuranceAdjust(e) {
    e.preventDefault();
    $('.account-health-insurance').removeClass('mx-4');
    $('.health-add-insurance__cancel-btn').trigger('click');
    validateAddRowButton();
  }

  function checkWindowWidth() {
    if ($(window).width() < 768) {
      $('.account-health-insurance__add').addClass('icon-add-insurance');
    } else {
      $('.account-health-insurance__add').removeClass('icon-add-insurance');
    }
  }

  checkWindowWidth();

  function saveAdjustInsurance(e) {
    const saveAdjustedUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountInsurance.saveAdjustedInsurancePlan}`;

    e.preventDefault();
    var $form = $(document).find('#CHHAdjustHealthInsuranceForm');
    $('.generic-error-container').addClass('hidden');
    const formData = $form.serialize();
    if (toggleSaveButtonState() === 0) {
      if (!onSaveAdjustedInsuranceAjaxReq) return false;
      onSaveAdjustedInsuranceAjaxReq = false;
      formPostJsonResponse(saveAdjustedUrl, formData)
        .then(data => {
          onSaveAdjustedInsuranceAjaxReq = true;
          data = JSON.parse(data);
          if (data.status === 'SUCCESS') {
            htmlGet(viewHealthInsurancesUrl).then(data => {
              attachAddInsuranceEvent();
              $('.view-insurance-remove-desc').addClass('hidden');
              $('.view-description').removeClass('hidden');
              loadingHtmlAfterAjax(data);
            });
          } else {
            $('.generic-error-container .generic-error-text').text(data.status);
            $('.generic-error-container').removeClass('hidden');
            window.scrollTo(0, 0);
          }
        })
        .catch(error => {
          onSaveAdjustedInsuranceAjaxReq = true;
          $('#adjustPlanErrorMsg').removeClass('hidden');
        });
    }
  }

  function toggleSaveButtonState() {
    var count = 0;
    var howManySelected = 0;
    $('select.health-remove-insurance-adjust-drop').each(function(
      index,
      element
    ) {
      if (!$(element)[0].validity.valid) {
        count = count + 1;
      }
    });
    if (count > 0) {
      $('#saveAdjustInsurance').attr('disabled', true);
    } else {
      $('#saveAdjustInsurance').attr('disabled', false);
    }
    return count;
  }

  function formatPhoneNo() {
    $('.payerPhoneNo').text(function(i, text) {
      text = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
      return text;
    });
  }

  function loadingHtmlAfterAjax(data) {
    $('.account_replace_section').html(ACC.utility.removeExtraTag(data));
    //removing extra account_replace_section tag
    $($('.healthinsurance').parent()).unwrap();
    formatPhoneNo();
    //activating accordion
    $('.section-toggler')
      .first()
      .click();
    $('.insurance-section-body').css('display', 'block');
    $('.health-remove-insurance').hide();
    $('.health-remove-insurance-search-section').hide();
    $('.health-remove-insurance-addnew-section').hide();
    $('.account-health-insurance__remove')
      .last()
      .addClass('lastelement');
    $('[data-toggle="tooltip"]').tooltip();
    setInsuranceActiveInactive();
  }

  function populateHierarchyDropdowns() {
    var valueArr = [];
    valueArr.push($(this).data('selected'));
    //Pushing selected values and selected insurance to an array
    $('.health-remove-insurance-adjust-drop option:selected').each(function(
      index,
      item
    ) {
      valueArr.push($(item).val() === '' ? 'none' : $(item).val());
    });
    //Creating selector string for hide/show of options
    var stringVal = '';
    for (var i = 0; i < valueArr.length; i++) {
      stringVal =
        stringVal + (i > 0 ? ',' : '') + 'option[value="' + valueArr[i] + '"]';
    }
    //Showing remaining options and hiding selected options which are not selected in other dropdowns
    $('.health-remove-insurance-adjust-drop')
      .not(this)
      .find(stringVal)
      .not(':selected')
      .attr('disabled', true);
    $('.health-remove-insurance-adjust-drop')
      .not(this)
      .find(':not(' + stringVal + ')')
      .attr('disabled', false);
    // Disabling select placeholder
    $('.health-remove-insurance-adjust-drop option:first-child').attr(
      'disabled',
      true
    );
    $('.health-remove-insurance-adjust-drop').selectmenu('refresh');
    toggleSaveButtonState();
  }

  function enableAddBtn() {
    $('.health-add-insurance__add-btn').removeAttr('disabled');
  }

  setInsuranceActiveInactive();
  formatPhoneNo();
  $('.health-add-insurance').hide();
  $('.health-remove-insurance').hide();
  $('.health-remove-insurance-search-section').hide();
  $('.health-remove-insurance-addnew-section').hide();
  $(document).on(
    'click',
    '.account-health-insurance__add',
    onClickAddInsurance
  );
  $(document).on(
    'click',
    '.account-health-insurance__remove',
    onClickRemoveInsurance
  );
  $('.account-health-insurance__remove')
    .last()
    .addClass('lastelement');
  $(document).on('input', '.custom-input-valid', validateInput);
  $(document).on(
    'selectmenuchange',
    '.health-add-insurance__select-policy',
    validateInput
  );
  $(document).on('selectmenuchange', '#stateInsurance', validateInput);

  $(document).on(
    'click',
    '.health-add-insurance__add-btn',
    onSubmitAddInsurance
  );
  $(document).on(
    'submit',
    '#health-add-remove-insurance-search',
    onSubmitAddInsuranceAdjust
  );
  $(document).on('submit', '#health-add-insurance', validateAllInputFields);
  $(document).on(
    'submit',
    '#health-remove-insurance',
    validateAllInputFieldsRemove
  );
  $(document).on('click', '.health-add-insurance__cancel-btn', onClickCancel);
  $(document).on('click', '#saveAdjustInsurance', saveAdjustInsurance);
  $(document).on(
    'click',
    '.health-add-insurance--search-btn',
    onClickCancelAdjustment
  );
  $(document).on(
    'change',
    'input[type=radio][name=removeInsurance]',
    onChangeInsuranceAdjustment
  );
  $(document).on(
    'change',
    'input[type=radio][name=insuranceType]',
    onChangeInsuranceType
  );
  $(document).on(
    'selectmenuchange',
    '.health-remove-insurance-adjust-drop',
    populateHierarchyDropdowns
  );
  $(document).on(
    'change',
    'input[type=radio][name=insuranceSearchResult]',
    enableAddBtn
  );
  validateAddRowButton();

  function loadData() {
    insuranceFlag = true;
    $('.custom-input-valid').each(function(i, el) {
      var $this = $(el);
      const isSelectSelected =
        $this.hasClass('health-add-insurance__select-state') ||
        $this.hasClass('health-add-insurance__select-policy');
      if ($this.val() === '') {
        insuranceFlag = false;
        $this.next('.error-msg-text').attr('hidden', false);
        $this.addClass('error-msg-textbox');
        if (isSelectSelected) {
          $this.siblings('.ui-selectmenu-button').addClass('error');
          $this
            .next()
            .next('.error-msg-text')
            .removeClass('hidden')
            .removeAttr('hidden');
        }
      }
    });
  }
  $(document).on('click', '.health-add-insurance__search-btn', loadData);

  var elements = document.getElementsByClassName('custom-input-valid');
  $.each(elements, function(i, inputVal) {
    inputVal.addEventListener('invalid', function(e) {
      e.preventDefault();
    });
  });
});
